import {
  Array,
  Boolean,
  Number,
  Record,
  Static,
  String,
  Undefined,
  Union,
} from "runtypes";
import { ResponseSummaryResponseRuntype } from "./IResponseSummaryResponse";

const ResponseScalarSummaryListRuntype = Record({
  averages: Array(
    Record({
      coachScore: Number,
      parentScore: Number,
      studentScore: Number,
      text: String,
    })
  ),
  coachTotalAverage: Number,
  parentTotalAverage: Number,
  studentTotalAverage: Number,
});

const ResponseWrittenRuntype = Record({
  response: String,
  surveyQuestionId: Number,
});

const SurveyScalarResponseSummariesRuntype = Record({
  expectations: ResponseScalarSummaryListRuntype,
  other: ResponseScalarSummaryListRuntype,
  parent: ResponseScalarSummaryListRuntype,
  warmth: ResponseScalarSummaryListRuntype,
});

const Question = Record({
  category: Number,
  coachText: String,
  id: Number,
  parentText: String,
  studentText: String,
});

export interface ISurveyScalarResponseSummaries
  extends Static<typeof SurveyScalarResponseSummariesRuntype> {}

export const SurveyEvaluationResponseRuntype = Record({
  coachCommitments: String,
  coachResponses: Array(ResponseWrittenRuntype),
  count: Record({
    coachCount: Number,
    parentCount: Number,
    studentCount: Number,
  }),
  directorComments: String,
  enableParentQuestions: Boolean,
  hasWrittenQuestions: Boolean,
  parentComments: String,
  parentResponses: Array(Union(String, Undefined)),
  questions: Array(Question),
  responseCollectionEndDate: Number,
  scaleResponseSummaries: SurveyScalarResponseSummariesRuntype,
  sportId: Number,
  startDate: Number,
  submitted: Boolean,
  type: Number,
  writtenResponseSummaries: Array(ResponseSummaryResponseRuntype),
});

export interface ISurveyEvalResponse
  extends Static<typeof SurveyEvaluationResponseRuntype> {}



// WEBPACK FOOTER //
// ./src/services/ISurveyEvaluationResponse.ts